import Cookies from 'universal-cookie';

export const inventoryCookies = new Cookies();
export const returnVisitor = "return-visitor";
export const inventoryFavourites = "inventory-favourites";

export const setReturnVisitorCookie = () => {
  if (!inventoryCookies.get(returnVisitor)) {
    inventoryCookies.set(returnVisitor, true, { expires: new Date(Date.now() + 12096e5), path: "/"});
  }
};

export const isReturnVisitor = () => {
  return Boolean(inventoryCookies.get(returnVisitor));
};
